import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "relative flex flex-col justify-between w-full py-3 px-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute space-y-1.5 handle top-3 left-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-5 h-0.5 bg-gray-400" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-5 h-0.5 bg-gray-400" }),
  /*#__PURE__*/_createElementVNode("div", { class: "w-5 h-0.5 bg-gray-400" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Base Value ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Choices ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" i ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Social ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold" }, "Dropdown Options", -1)
const _hoisted_11 = { class: "overflow-y-auto max-h-40" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = { class: "flex items-center justify-between py-1" }
const _hoisted_17 = { class: "text-sm" }

import { Extra } from '@/typings/scorecard';
import { PropType, onErrorCaptured, ref, computed } from 'vue';
import { useVModels } from '@vueuse/core';
import SearchDropdown from '../Inputs/SearchDropdown.vue';
import { SearchItem } from '@/typings/dropdown';
import { TemplateType } from '@/typings/template';
import InputField from '../Inputs/InputField.vue';
import Modal from '../Modal/Modal.vue';
import TextArea from '../Inputs/TextArea.vue';
import TextField from '../Inputs/TextField.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  extra: {
    type: Object as PropType<Extra>,
    required: true,
  },
},
  emits: ["remove"],
  setup(__props, { emit }: { emit: ({
  (e: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const types = ref<SearchItem[]>([
  {
    value: TemplateType.FreeText,
    text: 'Free text',
  },
  {
    value: TemplateType.Participants,
    text: 'All participating wrestlers',
  },
  {
    value: TemplateType.Number,
    text: 'Number +/- 1',
  },
  {
    value: TemplateType.Falls,
    text: 'All falls',
  },
  {
    value: TemplateType.NoDQFalls,
    text: 'No DQ Falls - Pin or submission only',
  },
  {
    value: TemplateType.CageFalls,
    text: 'Cage Falls - Pin, submission or escape',
  },
  {
    value: TemplateType.YesNo,
    text: 'Yes/No',
  },
  {
    value: TemplateType.AnyWrestler,
    text: 'All available wrestlers or custom',
  },
  {
    value: TemplateType.MultipleChoice,
    text: 'Custom Dropdown',
  },
  {
    value: TemplateType.Match,
    text: 'Match Names',
  },
  {
    value: TemplateType.OverUnder,
    text: 'Over/Under',
  },
]);

const { extra: extraModel } = useVModels(props);

const hint = computed(() => {
  if (extraModel.value.Type === TemplateType.MultipleChoice) {
    return extraModel.value.Options.join(', ');
  }
  if (extraModel.value.Type === TemplateType.OverUnder) {
    return extraModel.value.BaseValue.toString();
  }
  return undefined;
});

onErrorCaptured((err) => {
  console.error(err);
});

const userNotesEditorVisible = ref(false);
const socialFormatEditorVisible = ref(false);
const optionsEditorVisible = ref(false);
const baseValueEditorVisible = ref(false);
const newOption = ref('');

function addOption() {
  if (
    newOption.value.trim().length === 0 ||
    extraModel.value.Options.includes(newOption.value)
  )
    return;
  extraModel.value.Options.push(newOption.value);
  newOption.value = '';
}

function removeOption(index: number) {
  extraModel.value.Options.splice(index, 1);
}

function removeExtra() {
  emit('remove');
}

const isValid = computed(() => {
  const validText = extraModel.value.Text.length > 0;
  const validType = extraModel.value.Type && extraModel.value.Type.length > 0;
  let validSetup = true;
  switch (extraModel.value.Type) {
    case TemplateType.AnyWrestler:
    case TemplateType.CageFalls:
    case TemplateType.FreeText:
    case TemplateType.Match:
    case TemplateType.Falls:
    case TemplateType.NoDQFalls:
    case TemplateType.Number:
    case TemplateType.Participants:
    case TemplateType.YesNo:
      validSetup = true;
      break;
    case TemplateType.MultipleChoice:
      if (extraModel.value.Options.length === 0) {
        validSetup = false;
      }
      break;
    case TemplateType.OverUnder:
      if (!extraModel.value.BaseValue) {
        validSetup = false;
      }
      break;
    default:
      validSetup = false;
  }
  return validText && validType && validSetup;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["border-l-4", {
      'border-green-500': _unref(isValid),
      'border-red-500': !_unref(isValid),
      'line-through': _unref(extraModel).Deleted,
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(InputField, { hint: _unref(hint) }, {
          title: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              class: "font-bold w-96",
              placeholder: "Extra Text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(extraModel).Text) = $event))
            }, null, 512), [
              [_vModelText, _unref(extraModel).Text]
            ])
          ]),
          badge: _withCtx(() => [
            (_unref(extraModel).Type === _unref(TemplateType).OverUnder)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (baseValueEditorVisible.value = true)),
                  type: !_unref(extraModel).BaseValue ? 'other' : 'primary',
                  class: _normalizeClass({
              'bg-gray-400 hover:bg-gray-500': !_unref(extraModel).BaseValue,
            })
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["type", "class"]))
              : _createCommentVNode("", true),
            (_unref(extraModel).Type === _unref(TemplateType).MultipleChoice)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (optionsEditorVisible.value = true)),
                  type: !_unref(extraModel).Options.length ? 'other' : 'primary',
                  class: _normalizeClass({
              'bg-gray-400 hover:bg-gray-500': !_unref(extraModel).Options.length,
            })
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["type", "class"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (userNotesEditorVisible.value = true)),
              type: !_unref(extraModel).UserNotes.length ? 'other' : 'primary',
              class: _normalizeClass({
              'bg-gray-400 hover:bg-gray-500': !_unref(extraModel).UserNotes.length,
            })
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["type", "class"]),
            (_unref(extraModel).Type === _unref(TemplateType).Number)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  title: "Guess within 1 of final count earns points. +2 points for exact guess."
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (socialFormatEditorVisible.value = true)),
              type: !_unref(extraModel).SocialFormat.length ? 'other' : 'primary',
              class: _normalizeClass({
              'bg-gray-400 hover:bg-gray-500': !_unref(extraModel).SocialFormat.length,
            })
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["type", "class"]),
            _createVNode(_component_Button, { onClick: removeExtra }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["hint"]),
        _createVNode(SearchDropdown, {
          modelValue: _unref(extraModel).Type,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(extraModel).Type) = $event)),
          items: types.value
        }, null, 8, ["modelValue", "items"])
      ])
    ], 2),
    (baseValueEditorVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: "Edit Base Value",
          onClose: _cache[7] || (_cache[7] = ($event: any) => (baseValueEditorVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(TextField, {
              type: "number",
              modelValue: _unref(extraModel).BaseValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(extraModel).BaseValue) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (userNotesEditorVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 1,
          header: "Edit User Notes",
          onClose: _cache[9] || (_cache[9] = ($event: any) => (userNotesEditorVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(TextArea, {
              modelValue: _unref(extraModel).UserNotes,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(extraModel).UserNotes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (socialFormatEditorVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 2,
          header: "Edit Social Format",
          onClose: _cache[11] || (_cache[11] = ($event: any) => (socialFormatEditorVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(TextField, {
              modelValue: _unref(extraModel).SocialFormat,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(extraModel).SocialFormat) = $event)),
              hint: "{0} will be replaced with the answer"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (optionsEditorVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 3,
          header: "Edit Options",
          onClose: _cache[13] || (_cache[13] = ($event: any) => (optionsEditorVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extraModel).Options, (option, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index + option,
                    class: _normalizeClass([
            'flex items-center justify-between py-1',
            {
              'border-b': index !== _unref(extraModel).Options.length - 1,
            },
          ])
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(option), 1),
                    _createElementVNode("div", {
                      class: "text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-red-500 hover:opacity-100",
                      onClick: ($event: any) => (removeOption(index))
                    }, [
                      _createVNode(_component_fa_icon, { icon: "minus" })
                    ], 8, _hoisted_13)
                  ], 2))
                }), 128))
              ]),
              (_unref(extraModel).Options.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Empty"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(TextField, {
                      modelValue: newOption.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newOption).value = $event)),
                      title: "Custom Option",
                      onKeyup: _withKeys(addOption, ["enter"])
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _createElementVNode("div", {
                    class: "mt-4 text-xs text-gray-500 transition-all opacity-50 cursor-pointer hover:text-green-500 hover:opacity-100",
                    onClick: addOption
                  }, [
                    _createVNode(_component_fa_icon, { icon: "plus" })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})